<div class="dbPopupContent">	
    <div class="dbPopupHeader">DB Precache</div>  				 
        <mat-list>
            <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Last Cached Date </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{cachedDate}}</mat-list-item>							  
            </div>
            <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Last Cached Time </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{cachedTime}}</mat-list-item>								  
            </div>
            <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Total time taken </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{totTime}}</mat-list-item>								  
            </div>
            <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Status </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{statusText}}</mat-list-item>								 
            </div>              
        </mat-list>		
        
        <mat-divider></mat-divider>

        <div class="dbPopupQuestion" i18n>Initiate DB Precache</div> 
        <div class="dbPopupWarning" i18n>This process will empty all the precaching tables prior to start of the caching. Once started, this action cannot be revoked. Do you still want to continue?</div> 
        <div class="buttonContent">
            <button mat-raised-button type="button" tabindex="-1" [disabled]="cacheInProgress" color="primary" (click)="onStart()" i18n>START</button>
        </div>    
</div>